/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import styled from 'styled-components';
import BSGLOGO from '../../assets/icons/BSG.png';
import NewFooter from '../../components/Footer/NewFooter';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { Helmet } from 'react-helmet';

const HeaderContainer = styled.header`
  background-color: #53a8a0;
  display: flex;
  align-items: center;
  display: flex;
  height: 80px;
  @media (max-width: 767px) {
    flex-direction: column;
    height: auto;
    padding: 10px;
  }
`;
const Logo = styled.img`
  width: 50px;
  height: 50px;
`;
const LogoContainer = styled.div`
  width: 12%;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 767px) {
    align-items: flex-start;
    justify-content: flex-start;
    width: -webkit-fill-available;
  }
`;

const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  background: #e9e9e9;
`;

const ContainerIn = styled.div`
  width: 80%;
  padding: 30px;
  margin: 0 auto;
  background: #fff;
  box-sizing: border-box;
  @media (max-width: 767px) {
    width: 90%;
  }
`;

const AboutHeading = styled.h2`
  text-align: center;
  margin-top: 40px;
  font-size: 29px;
  font-family: sans-serif;
`;

const AboutSubHeading = styled.h4`
  font-size: 20px;
  margin-top: 35px;
  position: relative;
  display: inline-block;
  color: #479081;
  margin: 0;
`;

const ParagraphContent = styled.p`
  font-size: 16px;
  line-height: 25px;
`;
const NoticeText = styled.p`
  text-align: center;
  font-family: 'Noto Sans';
  font-style: italic;
  font-weight: 600;
  font-size: 18px;
  line-height: 175%;
  text-align: center;
  color: #51a69e;
  white-space: pre-wrap;
`;

const CancellationPolicy = () => {
  const navigate = useNavigate();
  const TITLE = 'Cancellation Policy - BSG Contribution Site';
  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <HeaderContainer>
        <LogoContainer onClick={() => navigate('/login')}>
          <Logo src={BSGLOGO} alt="Logo" />
        </LogoContainer>
      </HeaderContainer>
      <Container>
        <ContainerIn>
          <AboutHeading>Cancellation Policy</AboutHeading>
          <div />
          <AboutSubHeading>Terms and Conditions</AboutSubHeading>
          <ParagraphContent>
            Voluntary Contributions to Bharat Soka Gakkai
          </ParagraphContent>
          <ParagraphContent>
            By making the voluntary contributions through the use of the payment
            gateway provided in the website
            www.contribution.bharatsokagakkai.org, you agree to have read,
            understood and accepted the following terms and conditions on refund
            and cancellation of your contributions made by you:-
          </ParagraphContent>
          <ParagraphContent>
            I understand that once received, the contribution will not be
            cancellation can be made. The contribution will be used the
            objectives and purposes of Bharat Soka Gakkai.
          </ParagraphContent>
          <ParagraphContent>
            I understand that Bharat Soka Gakkai owns and retains the copyright
            and all other intellectual property rights in the contents of this
            website, including all the text, pictures, photographs, graphics,
            marks and logos displayed on this site.
          </ParagraphContent>
          <ParagraphContent>
            I understand that I am not entitled to reproduce any contents on the
            site for sale, distribution or commercial gain. No part of this site
            may be incorporated in any other work, publication or site in any
            form/format whatsoever. I shall also not be entitled to modify
            contents on this site for any purpose whatsoever.
          </ParagraphContent>
          <ParagraphContent>
            I understand that the information and contents on this site are for
            general purposes only and may not be relied upon for any specific
            purpose. Bharat Soka Gakkai makes no representation or warranty as
            regards the accuracy or completeness of any information and/or
            contents contained in this site.
          </ParagraphContent>
          <ParagraphContent>
            I understand that Bharat Soka Gakkai shall not be liable for the
            content of websites to which visitors of this website are referred.
            Links to such websites are provided only to complement information
            provided on this site.
          </ParagraphContent>
          <ParagraphContent>
            Bharat Soka Gakkai respects my privacy. They are committed to
            safeguarding the privacy of their customers' personal data. I
            understand that I have gone through the privacy policy of Bharat
            Gakkai incorporated under the Terms of Use of this site.
          </ParagraphContent>
          <ParagraphContent>
            With respect to Personal Information I provide (or any other
            information by me), I understand that it:
          </ParagraphContent>
          <ol>
            <li>shall not be false, inaccurate or misleading;</li>
            <li>shall not be fraudulent;</li>
            <li>
              shall not infringe any third party's copyright, patent, trademark,
              trade secret or other proprietary rights or rights of publicity or
              privacy;
            </li>
            <li>
              shall not violate any law, statute, ordinance or regulation
              (including without limitation those governing export control,
              consumer protection, unfair competition, anti discrimination or
              false advertising);
            </li>
            <li>
              shall not be defamatory, unlawfully threatening or unlawfully
              harassing;
            </li>
            <li>
              shall not contain any viruses, Trojan horses, worms, time bombs,
              cancel bots or other computer programming routines that are
              intended intended intended intended intended intended to damage,
              damage, detrimentally detrimentally surreptitiously intercept or
              expropriate any system, data or personal information;
            </li>
            <li>
              shall not create liability for us or cause us to lose (in whole or
              in part) the services of our ISPs (Internet Service Providers) or
              other suppliers.
            </li>
          </ol>
          <ParagraphContent>
            Any information that I may provide on this site shall form part of
            the database of Bharat Soka Gakkai and may be used by it and/or by
            by any of its affiliated / sister organizations and/or trusts only
            purpose of its/their activities and objects.
          </ParagraphContent>
          <Box sx={{ marginTop: '100px' }}>
            <NoticeText>
              “FOREIGN NATIONAL MEMBERS ARE NOT ALLOWED TO USE THIS SITE FOR
              MAKING CONTRIBUTION. IF ANY FOREIGN NATIONAL MEMBERS MAKES
              CONTRIBUTION THROUGH THIS SITE, BSG WOULD NOT ACCEPT THEIR
              CONTRIBUTION.”
            </NoticeText>
          </Box>
        </ContainerIn>
      </Container>
      <NewFooter />
    </>
  );
};

export default CancellationPolicy;
